import { render } from "./add-note.vue?vue&type=template&id=35e6d5ad"
import script from "./add-note.vue?vue&type=script&lang=js"
export * from "./add-note.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__